import type { ReactNode } from "react";

interface PanelShellProps {
  children: ReactNode;
  className?: string;
  contentClassName?: string;
  header?: ReactNode;
}

export const cx = (...classNames: Array<string | false | null | undefined>) =>
  classNames.filter(Boolean).join(" ");

export const PanelShell = ({
  children,
  className,
  contentClassName = "min-h-0 min-w-0 flex-1 overflow-hidden",
  header,
}: PanelShellProps) => (
  <section
    className={cx(
      "flex min-h-0 min-w-0 flex-col overflow-hidden rounded-xl border border-slate-200 bg-white shadow-sm",
      className,
    )}
  >
    {header}
    <div className={contentClassName}>{children}</div>
  </section>
);

